import * as z from 'zod';

import { ZolClientZod } from '@/types/ZolClientType';

const ClientPageRelationZod = z.object({
  id: z.number(),
  slug: z.string(),
  zolClient: ZolClientZod.nullable().optional(),
});

export { ClientPageRelationZod };
export type ClientPageRelationType = z.infer<typeof ClientPageRelationZod>;
